const PrivacyPage = () => (
  <div className="max-w-2xl mx-auto p-4">
    <h2 className="text-2xl font-bold mb-4">Privacy Policy</h2>
    <p>Your privacy policy text goes here...</p>
  </div>
);
export default PrivacyPage;
